<script lang="ts" setup>
const props = defineProps({
  clientPacksCount: {
    type: Number,
    required: true,
  },
})

const isClientHavePack = computed(() => props.clientPacksCount)

const info = computed(() =>
  !isClientHavePack.value
    ? 'Спасибо, что заботитесь об экологии и не заказываете приборы!'
    : 'В состав приборов входит вилка, ложка и салфетка',
)
</script>

<template>
  <span class="info" :class="{ 'info--success': !isClientHavePack }">
    {{ info }}
  </span>
</template>

<style lang="scss" scoped>
.info {
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: $dark-grey;

  &--success {
    color: $success;
  }
}
</style>
